import SimpleHeader from '../../../components/layout/SimpleHeader';
import SpeakingTestEditor from '../../../components/cbt/speaking-test/Editor';
import { useRouteMatch } from 'react-router';
import useNotification from '../../../hooks/useNotification';
import useAxios from '../../../hooks/useAxios';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import { IGetSpeaking, ISpeakingBody } from '../../../models/newSpeaking.model';
import { getSpeaking, putSpeaking } from '../../../api/newSpeaking.api';

interface IMatch {
  id: string;
}

const CbtSpeakingTestEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const speakingExamCode = String(match.params.id);
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeaking>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetSpeaking>();

  useEffect(() => {
    execute(getSpeaking(speakingExamCode));
  }, []);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.edit1'));
    }
  }, [submitRes]);

  const submit = (req: ISpeakingBody) => {
    submitExecute(putSpeaking(speakingExamCode, req));
  };

  return (
    <div className="content scrollbar">
      {(isLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingTest.1')}
        onlyTitle
      />
      <div>
        <SpeakingTestEditor
          data={res?.data}
          submit={submit}
        />
      </div>
    </div>
  );
};

export default CbtSpeakingTestEdit;
